import React from 'react';
import TopBar from './TopBar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <TopBar />
      <main className="flex-grow flex">
        {children}
      </main>
    </div>
  );
};

export default Layout;